export const updateFormStatus = () => {
  if (!window.wemove.page.shouldDisableForm) {
    return;
  }

  const form = document.querySelector("form[data-wm-floating-labels-form]");
  const formElements = form.querySelectorAll(
    "form submit, form [type=submit], form input, form textarea, form select"
  );

  form.classList.add("is-disabled");

  [...formElements].map((element) => {
    element.disabled = true;
  });
};
